<!-- src/components/InputField.vue -->
<template>
    <div class="input-group">
      <label :for="id">{{ label }}</label>
      <div class="input-with-icon">
        <i v-if="icon" :class="['fas', icon, 'icon']"></i>
        <input
          :id="id"
          :type="type"
          :placeholder="placeholder"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value)"
          required
        />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'InputField',
    props: {
      modelValue: { type: [String, Number], default: '' },
      id:         { type: String, required: true },
      label:      { type: String, default: '' },
      type:       { type: String, default: 'text' },
      placeholder:{ type: String, default: '' },
      icon:       { type: String, default: null }
    }
  };
  </script>
  
  <style scoped>
  .input-group label {
    display: block;
    text-align: left;
    margin-bottom: var(--space-sm, 6px);
    font-weight: 500;
    color: var(--color-text, #333);
  }
  .input-with-icon {
    position: relative;
  }
  .input-with-icon .icon {
    position: absolute;
    top: 50%;
    left: var(--space-sm, 12px);
    transform: translateY(-50%);
    color: var(--color-muted, #aaa);
  }
  .input-with-icon input {
    width: 100%;
    padding: var(--space-sm, 10px) var(--space-sm, 10px) var(--space-sm, 10px) var(--space-lg, 36px);
    border: 1px solid var(--color-border, #ccc);
    border-radius: 4px;
    font-size: var(--font-size-base, 14px);
  }
  </style>
  